import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { PlayerService } from 'src/app/shared/player.service';
import { User } from 'src/app/shared/user.model';
import { UserService } from 'src/app/shared/user.service';
import { ObjectivesService } from '../../services/objectives.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';

import { MatOption } from '@angular/material/core';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-new-keyresult-dialog',
    templateUrl: './new-keyresult-dialog.component.html',
    styleUrls: ['./new-keyresult-dialog.component.css'],
    imports: [ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatDialogActions, MatButton, MatDialogClose]
})
export class NewKeyresultDialogComponent implements OnInit {

 
  keyresultForm;
  users: User[];

  constructor(private fb: UntypedFormBuilder,
     private playerService: PlayerService,
     private objectiveService: ObjectivesService,
     private userService: UserService,
     public dialogRef: MatDialogRef<NewKeyresultDialogComponent>,
     @Inject(MAT_DIALOG_DATA) private data: {ObjectiveId: string, Owner: string}
     ) { }

     ngOnInit(): void {

      this.keyresultForm = this.fb.group({
        ObjectiveId: [this.data.ObjectiveId],
        Owner: [this.data.Owner, [Validators.required]],
        Title: ['',Validators.required],        
        KeyResultType: ['INTEGER'],
        TargetInteger: ['',Validators.required],
        BaselineInteger: ['',Validators.required],
        StartDate: [new Date(),Validators.required],
        TargetDate: ['',Validators.required],        
      });
  
      this.userService.getAllUsers().subscribe(data=>{
        this.users =  data as User[];
      });
  
     
  
  
    }   

  onSubmit(){
    // TODO: Use EventEmitter with form value
    //console.warn(this.keyresultForm.value);
    //console.log(this.keyresultForm.valid);
    this.objectiveService.addKeyResult(this.keyresultForm.value).subscribe(res=>{
      this.dialogRef.close();
    });
  }

}
